<template lang="pug">
  .product-display--wrapper(v-if="product")
    .product-display
      .row
        .product-display__content(v-if="$mq !== 'mobile'")
          .product-info
            slot(name="content")
          product-form-gift-card(v-if="product.type === 'Gift Card'" :product="product")
          product-form(v-else :product="product" :metafield-default-subscription="metafieldDefaultSubscription")
          slot(name="icons")
    .container(v-if="$mq === 'mobile'")
      .row
        .column.small-12
          .product-info(v-if)
            slot(name="content")
          product-form-gift-card(v-if="product.type === 'Gift Card'" :product="product")
          product-form(v-else :product="product" :metafield-default-subscription="metafieldDefaultSubscription")
          slot(name="icons")
  .product-display--placeholder(v-else)
</template>

<script>
  import storeProduct from 'scripts/mixins/storeProduct.js';

  import ProductForm from 'scripts/components/product/ProductForm.vue';
  import ProductFormGiftCard from 'scripts/components/product/ProductFormGiftCard.vue';

  export default {
    name: 'PopProductDisplay',
    mixins: [
      storeProduct,
    ],
    props: {
      metafieldDefaultSubscription: String
    },
    components: {
      ProductForm,
      ProductFormGiftCard,
    },
    computed: {},
    mounted() {
      
    },
	watch: {
		product: function() {
			console.log('watch ran 3', this.product)
			let iterations = 0;
			let interval = setInterval(() => {
				if (window.yotpo && window.yotpo.initialized) {
				let api = new Yotpo.API(window.yotpo);
				api.refreshWidgets();
				clearInterval(interval);
				}

				iterations += 1;

				if (iterations >= 100) {
				clearInterval(interval);
				}
			}, 1000);
		}
	}
  };
</script>

<style scoped lang="scss">
  .product-display {
    position: relative;
    margin-bottom: 0;
    padding-bottom: 0;

    @include desktop-up {
      margin-bottom: 0;
    }

    &--wrapper {
      @include mobile-only {
        padding-bottom: 24px;
      }
    }

    .row {
      display: block;
    }

    .hero__background {
      @include mobile-only {
        display: none;
      }

      bottom: 120px;
    }

    & > .container {
      margin-top: 24px;

      @include tablet-up {
        z-index: 1;
        position: relative;
        margin-top: 32px;
      }
    }
  }

  .product-display__content {
    max-width: 100%;
  }

  .product-slider__background {
    position: absolute;
    left: 0;
    right: 0;
    top: -24px;
    height: 165px;
    background-size: cover;
    background-position: center;

    @include tablet-only() {
      display: none;
    }

    @include desktop-up() {
      display: block;
      top: -32px;
      left: 0;
      right: calc(50% + 250px);
      height: 830px;
    }
  }

  .container {
    @include desktop-up() {
      min-height: 800px;
    }
  }

  .product-info__title-wrapper {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include tablet-up {
      margin-bottom: 10px;
      flex-direction: row;
      align-items: flex-end;
    }

    .product-info__title {
      margin-bottom: 0;
    }
  }

  .product-info__title {
    color: $color-indigo;
    margin-right: 15px;
  }

  .product-info__price {
    font-size: rem(20);
    line-height: 1.5;
    font-weight: 400;
    font-family: $font-sweet-sans;
    color: $color-indigo;
  }

  .product-info__description {
    font-family: $font-gibson;
    color: $color-charcoal;

    @include mobile-only {
      font-size: rem(16);
    }
  }

  .product-display--placeholder {
    min-height: 100vh;
  }
</style>
